import React from 'react';
import PaginationBase from '../../../common/base/PaginationBase';
import { message } from 'antd';

import {
    VENTA_GUIA_REMISION_GENERA_SALIDAS,
    CONTROL_COMPBANTE
} from '../../../common/types/parametroType';
import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { FACTURA, OTROS, GUIA_TRANSPORTISTA } from '../../../common/types/tipoComprobanteType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';
import { SERVICIO } from '../../../common/types/tipoProductoType';
import { PRIVADO } from '../../../common/types/modalidadTrasladoType';
import { LOGISTICA } from '../../../common/types/sistemaType'
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import auth from '../../../common/utility/auth';
import printFormatMock from '../../../common/mock/printFormatMock';

import listaPrecioService from '../../../service/administracion/listaPrecioService';
import tipoCambioDiarioService from '../../../service/administracion/tipoCambioDiarioService';
import establecimientoService from '../../../service/administracion/establecimientoService';
import almacenService from '../../../service/administracion/almacenService';
import vendedorService from '../../../service/administracion/vendedorService';
import padronReducidoService from '../../../service/integracion/padronReducidoService';
import entidadService from '../../../service/administracion/entidadService';
import tipoComprobanteService from '../../../service/administracion/tipoComprobanteService';
import productoService from '../../../service/administracion/productoService';
import proyectoService from '../../../service/administracion/proyectoService';

import vehiculoService from '../../../service/logistica/vehiculoService';
import choferService from '../../../service/logistica/choferService';
import guiaTransportista from '../../../service/logistica/guiaTransportista';
import ubigeoService from '../../../service/integracion/ubigeoService';
import comprobanteService from '../../../service/ventas/comprobanteService';
import guiaService from '../../../service/logistica/guiaService';

import configuracionService from '../../../service/seguridad/usuarioConfiguracionService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';
import ImportarModal from './ImportarModal';
import FormModalVer from './FormModalVer';
import SearchProductModal from './SearchProductModal';
import RenombrarProductoModal from './RenombrarProductoModal';
import ImprimirModal from './ImprimirModal';
import CdrModal from './CdrModal';
import { VENTA } from '../../../common/types/moduloType';
import { VER_SERIES_VENTA, EMI_GUIA_AUTO, EDIT_COD_GUIA } from '../../../common/types/configuracionType';


var formValuesComprobante = {
    listaComprobanteDetalle: [],
    listaComprobanteReferencia: [],
    productos: [],
    idComprobante: 0
}

var referenciaCount = 1;

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();

        this.state = {
            loadingSource: true,
            loadingVer: false,
            loadingImprimir: false,
            loadingXml: false,
            tiposCambioDiario: [],
            indicadorSunat: [],
            vendedores: [],
            destinatarios: [],
            tiposGuia: [],
            vehiculos: [],
            choferes: [],
            direccionesPartidas: [],
            tiposComprobante: [],
            productos: [],
            proyectos: [],
            estado: [],
            configuraciones: [],

            departamentosPartida: [],
            provinciasPartida: [],
            distritosPartida: [],
            remitentes: [],
            departamentosLlegada: [],
            provinciasLlegada: [],
            distritosLlegada: [],
            terceros: [],
            comprobantes: [],
            totaldocument: [],
            cdrVisible: false,
            selectedItem: {},
            company: {},
            filter: {
                remitente: "",
                idTipoComprobante: GUIA_TRANSPORTISTA.ID,
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                serie: '',
                documento: '',
                idEstado: 0,
                idProyecto: 0,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            productoVisible: false,
            importarOCVisible: false,
            visibleVer: false,
            renombrarProductoVisible: false,
            importarComprobanteModalVisible: false,
            formValues: this.fetchEmptyFormValues(),
            onSetFieldsValue: null,
            onGetFieldValue: null,
            searchProductVisible: false,
            searchProductFormValues: {
                validarStock: false,
                dataSource: []
            },
            productoModal: {
                nombre: '',
                dataSource: [],
                selectedRowKeys: []
            },
            renombrarProductoModal: {
                nombre: '',
                idProducto: 0,
                identifier: ''
            },
            importarComprobanteModal: {
                nombre: '',
                dataSource: []
            },
            imprimirFormValues: {
                file: undefined,
                idGuiaRemision: 0,
                idFormato: 0,
                formatos: printFormatMock.values
            },

            importarComprobanteVisible: false,
            importarFormValues: {
                nombre: "",
                dataSource: [],
                selectedRowKeys: [],
            },
            correoFormValues: {
                file: undefined,
                idComprobante: 0,
                idFormato: 0,
                correoCliente: '',
                formatos: printFormatMock.values
            },
            onSetFieldsValue: null,
            onGetFieldValue: null,
            ubigeos: [],
            prodsArrDetalle: []
        }
    }

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleClearFilters = () => {
        var filter = {
            idDestinatario: 0,
            idMotivo: 0,
            idTipoComprobante: FACTURA.ID,
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            serie: '',
            documento: '',
            remitente: "",
            idEstado: 0,
            idTraslado: 0,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleChangeForm = async (property, value, form) => {

        if (property === "idDestinatario") {

            const direcciones = await establecimientoService.listarPorIdEntidad(value);
            const direccionPrincipal = direcciones.length > 0 ? direcciones[0] : undefined;
            const provinciasLlegada = await ubigeoService.provincias(direccionPrincipal.idDepartamento);
            const distritosllegada = await ubigeoService.distritos(direccionPrincipal.idProvincia);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    provinciasLlegada: provinciasLlegada ? provinciasLlegada : [],
                    distritosLlegada: distritosllegada ? distritosllegada : [],
                    direccionesLlegadas: direcciones,
                    idEstablecimientoDestino: direccionPrincipal.id

                }
            }, () => {

                form.setFieldsValue({
                    direccionDestino: direccionPrincipal.direccion,
                    idEstablecimientoDestino: { key: direccionPrincipal.id },

                    idDepartamentoLlegada: direccionPrincipal.idDepartamento > 0 ? { key: direccionPrincipal.idDepartamento } : undefined,
                    idProvinciaLlegada: direccionPrincipal.idProvincia > 0 ? { key: direccionPrincipal.idProvincia } : undefined,
                    idDistritoLlegada: direccionPrincipal.idUbigeo > 0 ? { key: direccionPrincipal.idUbigeo } : undefined,
                });
            });
        }

        if (property === "idRemitente") {

            const direcciones = await establecimientoService.listarPorIdEntidad(value);
            const direccionPrincipal = direcciones.length > 0 ? direcciones[0] : undefined;
            const provinciasLlegada = await ubigeoService.provincias(direccionPrincipal.idDepartamento);
            const distritosllegada = await ubigeoService.distritos(direccionPrincipal.idProvincia);
            if (direcciones.length == 0) {
                dialog.error('Remitente no tiene dirección registrada');
                return false
            }

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    provinciasPartida: provinciasLlegada ? provinciasLlegada : [],
                    distritosPartida: distritosllegada ? distritosllegada : [],
                    idEstablecimientoPartida: direccionPrincipal.id,
                    direccionesPartidas: direcciones
                }
            }, () => {

                form.setFieldsValue({
                    direccionPartida: direccionPrincipal.direccion,
                    idEstablecimientoPartida: { key: direccionPrincipal.id },
                    idDepartamentoPartida: direccionPrincipal.idDepartamento > 0 ? { key: direccionPrincipal.idDepartamento } : undefined,
                    idProvinciaPartida: direccionPrincipal.idProvincia > 0 ? { key: direccionPrincipal.idProvincia } : undefined,
                    idDistritoPartida: direccionPrincipal.idUbigeo > 0 ? { key: direccionPrincipal.idUbigeo } : undefined,
                });
            });
        }



        if (property === "idChofer") {
            const vehiculos = this.state.vehiculos.filter(m => m.idModalidadTraslado === PRIVADO);
            const chofer = this.state.choferes.filter(m => m.id == value);
            const licencia = chofer.length > 0 ? chofer[0].licencia : null;

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    idVehiculo: undefined,
                    licencia: licencia,
                    vehiculosSecundarios: [],
                    choferesSecundarios: [],
                    tuc: chofer.length > 0 ? chofer[0].tuc : null,
                    vehiculos: vehiculos ? vehiculos : [],
                    tuc: ''
                }
            });
            form.setFieldsValue({
                tuc: ''
            });
        }


        if (property === "idEstablecimientoPartida") {

            const direccion = await establecimientoService.obtenerPorId(value);
            const provinciasPartida = await ubigeoService.provincias(direccion.idDepartamento);
            const distritosPartida = await ubigeoService.distritos(direccion.idProvincia);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    provinciasPartida: provinciasPartida ? provinciasPartida : [],
                    distritosPartida: distritosPartida ? distritosPartida : [],
                }
            }, () => {

                form.setFieldsValue({
                    idDepartamentoPartida: { key: direccion.idDepartamento === 0 ? undefined : direccion.idDepartamento },
                    idProvinciaPartida: { key: direccion.idProvincia === 0 ? undefined : direccion.idProvincia },
                    idDistritoPartida: { key: direccion.idUbigeo === 0 ? undefined : direccion.idUbigeo }
                });
            });
        }

        if (property === "idEstablecimientoDestino") {

            const direccion = await establecimientoService.obtenerPorId(value);
            const provinciasPartida = await ubigeoService.provincias(direccion.idDepartamento);
            const distritosPartida = await ubigeoService.distritos(direccion.idProvincia);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    provinciasLlegada: provinciasPartida ? provinciasPartida : [],
                    distritosLlegada: distritosPartida ? distritosPartida : [],
                }
            }, () => {

                form.setFieldsValue({
                    idDepartamentoLlegada: { key: direccion.idDepartamento === 0 ? undefined : direccion.idDepartamento },
                    idProvinciaLlegada: { key: direccion.idProvincia === 0 ? undefined : direccion.idProvincia },
                    idDistritoLlegada: { key: direccion.idUbigeo === 0 ? undefined : direccion.idUbigeo }
                });
            });
        }


        if (property === "idDepartamentoPartida") {
            const provincias = await ubigeoService.provincias(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    provinciasPartida: provincias
                }
            });
        }
        if (property === "idProvinciaPartida") {
            const _distritos = await ubigeoService.distritos(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    distritosPartida: _distritos
                }
            });
        }
        if (property === "idDepartamentoLlegada") {
            debugger
            const provincias = await ubigeoService.provincias(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    provinciasLlegada: provincias
                }
            });
        }
        if (property === "idProvinciaLlegada") {
            debugger
            const _distritos = await ubigeoService.distritos(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    distritosLlegada: _distritos
                }
            });
        }

        if (property === "direcciones-clear") {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    idDestinatario: undefined,
                    documentoDestinatario: "",
                    direccionLlegada: "",
                    idDepartamentoLlegada: undefined,
                    idProvinciaLlegada: undefined,
                    idDistritoLlegada: undefined,
                    provinciasLlegada: [],
                    distritosLlegada: [],

                    direcciones: [],
                }
            })
        }
        if (property === "direcciones-clear-provv") {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    idRemitente: undefined,
                    documentoRemitente: "",
                    idEstablecimientoProveedor: undefined,
                    documentoRemitente: "",
                }
            })
        }
    }

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            idProyecto: -1,
            idEntidad: 0, //..........................................................OK
            idVendedor: 0,
            idEstablecimientoCliente: 0,
            idVehiculo: 0,
            idChofer: 0,
            idUsuarioRegistro: auth.user().id,
            idEstablecimientoPartida: 0,
            idEstablecimientoDestino: 0,
            idDepartamentoPartida: 0,
            idProvinciaPartida: 0,
            idDistritoPartida: 0,
            idIndicadorSunat: 1,
            proyectos: [],
            idDepartamentoLlegada: 0,
            idProvinciaLlegada: 0,
            idDistritoLlegada: 0,
            direccionPartida: "",
            direccionLlegada: "",
            serie: "",
            tuc: "",
            nroMtc: "",
            documentoTercero: "",
            razonSocialTercero: "",
            idTercero: 0,
            flagTercero: false,
            flagSubcontrato: false,
            documento: "", //............................................... OK
            fechaStr: global.fetchCurrentDateStr(), //......................................... OK
            fechaTrasladoStr: global.fetchCurrentDateStr(), //......................................... OK
            observacion: "", //..........................................................OK
            detalleProductos: [],
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            sumaSubTotal: 0,
            sumaIgv: 0,
            sumaTotal: 0,
            totalPeso: 0,
            destinatarioLoading: false,
            activeKey: "1",
            idRemitente: 0,
            documentoRemitente: '',
            entidades: [],
            terceros: [],
            direccionesPartidas: [],
            direccionesLlegadas: [],
            direcciones: [],
            departamentosPartida: [],
            provinciasPartida: [],
            distritosPartida: [],
            tiposComprobante: [],
            departamentosLlegada: [],
            provinciasLlegada: [],
            distritosLlegada: [],
            destinatarios: [],
            vendedores: [],
            tiposGuia: [],
            vehiculos: [],
            vehiculosSecundarios: [],
            choferes: [],
            choferesSecundarios: [],
            remitentes: [],
            indicadorSunat: [],
            numeroDocumentoEntidad: '',
            flagEditdireccionPartida: false,
            flagEditdireccionDestino: false,
        }
    }


    handleNew = async () => {

        var params = auth.user().parametros;
        var paramGuiaRemisionGeneraSalidas = params.filter((m) => m.abreviatura === VENTA_GUIA_REMISION_GENERA_SALIDAS)[0].valor === "1"
            ? true
            : false;

        var flagEditCode = this.state.configuraciones.filter((m) => m.abreviatura === EDIT_COD_GUIA).length >= 1 ? true : false;

        var controlDcumento = params.filter((m) => m.abreviatura === CONTROL_COMPBANTE)[0].valor === "1" ? true : false;
        if (controlDcumento) {
            if (this.state.totaldocument[0].total > auth.user().totalDocumentos) {
                message.error('Usted no puede crear comprobantes. ya supero la cantidad contratada');
                return;
            }
        }


        var formValues = this.fetchEmptyFormValues();
        formValues.flagGuiaRemisionGeneraSalidas = paramGuiaRemisionGeneraSalidas;
        formValues.monedas = this.state.monedas;
        formValues.vendedores = this.state.vendedores;
        formValues.destinatarios = this.state.destinatarios;
        formValues.remitentes = this.state.remitentes;
        formValues.proyectos = this.state.proyectos;
        formValues.vehiculos = this.state.vehiculos;
        formValues.choferes = this.state.choferes;
        formValues.indicadorSunat = this.state.indicadorSunat;
        formValues.flagEditCode = flagEditCode;
        formValues.tiposComprobante = this.state.tiposComprobante;
        formValues.serie = this.state.filter.serie;
        const departamentos = await ubigeoService.departamentos()

        formValues.departamentosPartida = departamentos;
        formValues.departamentosLlegada = departamentos;

        const datosIniciales = await comprobanteService.datosIniciales({ idUsuario: auth.user().id, idTipoComprobante: GUIA_TRANSPORTISTA.ID });
        if (datosIniciales !== undefined) {
            formValues.serie = datosIniciales.serie;
            formValues.idVendedor = datosIniciales.idVendedor;
            formValues.idAlmacen = datosIniciales.idAlmacen;
            formValues.idEstablecimiento = datosIniciales.idEstablecimiento;
            formValues.idListaPrecio = datosIniciales.idListaPrecio;
        }

        if (formValues.serie == "" || formValues.serie == null) {
            setTimeout(() => {
                dialog.error("Tiene que registrar serie correlativo para poder emitir el documento");

            }, 100);

        } else {

            this.setState({
                visible: true,
                formValues,
            });
        }


    }

    handleOnChangeEntidad = async (value) => {

        const numeroDoc = value.label.split('-')[value.label.split('-').length - 1];
        this.setState({
            formValues: {
                ...this.state.formValues,
                numeroDocumentoEntidad: numeroDoc,
                direccionesLlegadas: []
            }
        });

        const direccionesEstablecimientos = await establecimientoService.listarPorIdEntidad(value.key);

        if (direccionesEstablecimientos === undefined) {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    direccionesLlegadas: [],
                    numeroDocumentoEntidad: ''
                }
            });
        } else {

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    direccionesLlegadas: direccionesEstablecimientos
                }
            });

            if (direccionesEstablecimientos.length === 1) {
                var llegada = direccionesEstablecimientos[0];
                const _ubigeo = this.state.ubigeos.filter(m => m.id === llegada.idUbigeo)[0];
                const _ubigeoDep = this.state.ubigeos.filter(m => m.codigo === '0000' + _ubigeo.codigo.substring(0, 2))[0];
                const _ubigeoProv = this.state.ubigeos.filter(m => m.codigo === '00' + _ubigeo.codigo.substring(0, 4))[0];

                const departamentos = await ubigeoService.departamentos()
                const provincias = await ubigeoService.provincias(_ubigeoDep.id);
                const distritos = await ubigeoService.distritos(_ubigeoProv.id);

                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        idDireccionLlegada: llegada.id,
                        departamentosLlegada: departamentos,
                        provinciasLlegada: provincias,
                        distritosLlegada: distritos,
                        idDepartamentoLlegada: _ubigeoDep.id,
                        idProvinciaLlegada: _ubigeoProv.id,
                        idDistritoLlegada: llegada.idUbigeo
                    }
                });
            }
        }
    }

    handleChangeTab = (key) => {
        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: key
            }
        });
    };


    handleBuscarRemitente = async (value, form) => {
        this.setState({ formValues: { ...this.state.formValues, remitenteLoading: true } });


        var numberDocument = value;
        if (numberDocument == "" || numberDocument == "null" || numberDocument == "undefined") {
            dialog.warning(<ul>Ingrese documento valido</ul>);

            return;
        }

        var response = numberDocument.length == 8 ? await padronReducidoService.obtenerDniApi(value) :
            await padronReducidoService.obtenerRucApi(value);

        if (response.status === 200) {
            const provinciasLlegada = await ubigeoService.provincias(response.data.direcciones[0].idDepartamento);
            const distritosLlegada = await ubigeoService.distritos(response.data.direcciones[0].idProvincia);

            const filterEntidad = {
                numeroDocumento: null,
                idTipoComprobante: OTROS.ID// FACTURA.ID
            }
            const entidades = await entidadService.obtenerTodos(filterEntidad);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    remitenteLoading: false,
                    documentoRemitente: response.data.numeroDocumento,
                    provinciasPartida: provinciasLlegada,
                    distritosPartida: distritosLlegada,
                    direccionesPartidas: response.data.direcciones,
                    direccionPartida: response.data.direcciones[0].direccion,
                },
                remitentes: entidades
            }, () => {
                form.setFieldsValue({
                    remitentes: entidades,
                    documentoRemitente: response.data.numeroDocumento,
                    idRemitente: response.data.clientes.length > 0 ? { key: response.data.idEntidad } : undefined,
                    idEstablecimientoPartida: response.data.direcciones.length > 0 && response.data.direcciones[0].id ? { key: response.data.direcciones[0].id } : undefined,
                    idDepartamentoPartida: response.data.direcciones.length > 0 && response.data.direcciones[0].idDepartamento != 0 ? { key: response.data.direcciones[0].idDepartamento } : undefined,
                    idProvinciaPartida: response.data.direcciones.length > 0 && response.data.direcciones[0].idProvincia != 0 ? { key: response.data.direcciones[0].idProvincia } : undefined,
                    idDistritoPartida: response.data.direcciones.length > 0 && response.data.direcciones[0].idUbigeo != 0 ? { key: response.data.direcciones[0].idUbigeo } : undefined
                });
            });
        }
        else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    remitenteLoading: false,
                    direcciones: [],
                }
            }, () => {
                form.setFieldsValue({
                    destinatarios: [],
                    idProvinciaPartida: undefined,
                    idDepartamentoPartida: undefined,
                    idUbigeo: undefined,
                    idRemitente: undefined,
                    idEstablecimientoRemitente: undefined
                });
            });
        }
    };


    handleBuscarTercero = async (value, form) => {
        this.setState({ formValues: { ...this.state.formValues, remitenteLoading: true } });
        var numberDocument = value;
        if (numberDocument == "" || numberDocument == "null" || numberDocument == "undefined") {
            dialog.warning(<ul>Ingrese documento valido</ul>);

            return;
        }

        var response = await padronReducidoService.obtenerRucApi(value);

        if (response.status === 200) {


            this.setState({
                formValues: {
                    ...this.state.formValues,
                    remitenteLoading: false,
                    documentoTercero: response.data.numeroDocumento,
                    razonSocialTercero: response.data.nombreRazonSocial,
                    terceros: response.data.clientes,
                },
                terceros: response.data.clientes,
            }, () => {
                form.setFieldsValue({
                    terceros: response.data.clientes,
                    documentoTercero: response.data.numeroDocumento,
                    razonSocialTercero: response.data.nombreRazonSocial,

                });
            });
        }
        else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    remitenteLoading: false,
                }
            }, () => {
                form.setFieldsValue({
                    terceros: [],
                    idTercero: undefined,
                    documentoTercero: undefined,
                    razonSocialTercero: undefined,


                });
            });
        }
    };

    handleAgregarDetalle = (onSetFieldsValue, onGetFieldValue) => {

        this.setState({
            onSetFieldsValue,
            onGetFieldValue
        }, () => {
            if (this.state.formValues.activeKey === "1")
                this.handleOpenSearchProductModal();

            if (this.state.formValues.activeKey === "2")
                this.handleAddReferencia();
            if (this.state.formValues.activeKey === "3")
                this.handleAddVehiculo();

            if (this.state.formValues.activeKey === "4")
                this.handleAddChofer();
        });
    };


    handleAddChofer = () => {
        var choferesSecundarios = this.state.formValues.choferesSecundarios;

        choferesSecundarios.push({
            identifier: global.fetchUniqueCode(),
            idChofer: 0,
            licencia: ""
        });

        this.setState({
            formValues: {
                ...this.state.formValues,
                choferesSecundarios: choferesSecundarios
            }
        });

        this.state.onSetFieldsValue({ choferesSecundarios });
    };

    handleRemoverChofer = (item, form) => {


        this.setState({
            formValues: {
                ...this.state.formValues,
                choferesSecundarios: this.state.formValues.choferesSecundarios.filter(m => m.identifier !== item.identifier)
            },
        }, () => {
            var arrDetalle = form.getFieldValue('choferesSecundarios');
            form.setFieldsValue({
                choferesSecundarios: arrDetalle.filter(m => m.identifier !== item.identifier)
            });
        });
    };



    handleAddVehiculo = () => {
        debugger
        var vehiculosSecundarios = this.state.formValues.vehiculosSecundarios;

        vehiculosSecundarios.push({
            identifier: global.fetchUniqueCode(),
            placa: "",
            tuc: "",
        });

        this.setState({
            formValues: {
                ...this.state.formValues,
                vehiculosSecundarios: vehiculosSecundarios
            }
        });

        this.state.onSetFieldsValue({ vehiculosSecundarios });
    };

    handleRemoverVehiculo = (item, form) => {

        this.setState({
            formValues: {
                ...this.state.formValues,
                vehiculosSecundarios: this.state.formValues.vehiculosSecundarios.filter(m => m.identifier !== item.identifier)
            },
        }, () => {
            var arrDetalle = form.getFieldValue('vehiculosSecundarios');
            form.setFieldsValue({
                vehiculosSecundarios: arrDetalle.filter(m => m.identifier !== item.identifier)
            });
        });
    };


    handleAddReferencia = () => {
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia;

        listaComprobanteReferencia.push({
            identifier: global.fetchUniqueCode(),
            idReferencia: 0,
            idReferenciaOrigen: 0,
            idTipoComprobante: 0,
            series: "",
            documentos: "",
            flagInterno: true
        });

        referenciaCount = referenciaCount + 1;

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            }
        });
    };

    handleRemoverReferencia = (item) => {
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia.filter(m => m.identifier !== item.identifier);
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            }
        });
    };

    handleOpenSearchProductModal = async () => {


        var filter = {
            idAlmacen: 0,
            idListaPrecio: 0,
            idMoneda: 1,
            IdSistema: 2
        }
        var response = await productoService.Sinstock(filter);

        this.setState({
            searchProductVisible: true,
            searchProductFormValues: {
                ...this.state.searchProductFormValues,
                validarStock: response.validarStock,
                dataSource: response.productos.filter(m => m.idTipoProducto !== SERVICIO)
            }
        });
    };

    handleBuscarProducto = async (value) => {


        var filter = {
            idAlmacen: 0,
            idListaPrecio: 0,
            idMoneda: 1,
            idSistema: LOGISTICA,
            codigoNombre: value
        }

        const response = await productoService.Sinstock(filter);
        this.setState({
            searchProductVisible: true,
            searchProductFormValues: {
                ...this.state.searchProductFormValues,
                validarStock: response.validarStock,
                dataSource: response.productos
            }
        });
    };

    handleSelectProduct = (row) => {

        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;
        var listEmpty = this.state.formValues.listaComprobanteDetalle.length;

        var item = {
            identifier: global.fetchUniqueCode(),
            idProducto: row.id,
            codigo: row.codigoReferencia,
            nombre: row.nombre,
            nombreUnidadMedida: row.nombreUnidadMedida,
            idUnidadMedida: row.idUnidadMedida,
            flagAfecto: row.flagIGVAfecto,
            flagGratuito: row.flagGratuito,
            flagExonerado: row.flagExonerado,
            cantidad: 0,
            dam: "",
            pesoUnitario: row.pesoUnitario,
            totalPeso: 0,
            fechaVencimiento: '',
            numeroLote: row.numeroLote,
            stock: row.stockDisponible,
            flagConversion: false,

        };

        listaComprobanteDetalle.push(item);

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle
            }
        }, () => {
            var producto = {
                identifier: item.identifier,
                idProducto: item.idProducto,
                codigo: item.codigoReferencia,
                nombre: item.nombre,
                numeroLote: item.numeroLote,
                idUnidadMedida: row.idUnidadMedida,
                cantidad: item.cantidad,
                pesoUnitario: item.pesoUnitario,
                totalPeso: item.totalPeso,
                flagAfecto: item.flagAfecto,
                flagGratuito: item.flagGratuito,
                flagExonerado: item.flagExonerado,
                subTotal: 0,
                igv: 0,
                pesoUnitario: 0,
                flagConversion: false,
            };

            var detalleProductos = this.state.onGetFieldValue('detalleProductos');
            if (listEmpty === 0) {
                detalleProductos = [];
            }
            detalleProductos.push(producto);
            this.state.onSetFieldsValue({ detalleProductos });
        }
        );
    };


    handleScanerProduct = async (value, onSetFieldsValue, onGetFieldValue) => {
        this.setState({
            onSetFieldsValue,
            onGetFieldValue,
        });
        // dialog.confirm(
        //   "El total de la venta excede el monto máximo establecido ¿Desea continuar?",
        //   async () => {

        var idAlmacen = this.state.onGetFieldValue('idAlmacen');

        if (idAlmacen === undefined) {
            message.warning('Por favor seleccione un almacén.');
            return;
        }

        /* PARAMETROS */
        /* LSITA */
        var listaComprobanteDetalle = this.state.formValues
            .listaComprobanteDetalle;
        var filter_detalle = listaComprobanteDetalle.filter(
            (m) => m.codigoBarra === value
        );

        var item = {};
        if (filter_detalle.length > 0) {
            listaComprobanteDetalle = listaComprobanteDetalle.filter(
                (m) => m.codigoBarra !== value
            );
            var item = filter_detalle[0];
            item.cantidad = item.cantidad + 1;
        } else {
            var filter = {
                idAlmacen: idAlmacen.key,
                idSistema: LOGISTICA,
                codigoNombre: value
            };

            var list = await productoService.stock(filter);
            var filter_list = list.productos.filter(
                (m) => m.codigoBarra === value
            );
            if (filter_list.length === 0) {
                alert("no existe el producto");
                return;
            }
            var row = filter_list[0];

            var item = {
                identifier: global.fetchUniqueCode(),
                idProducto: row.id,
                codigo: row.codigoReferencia,
                codigoBarra: row.codigoBarra,
                nombre: row.nombre,
                nombreUnidadMedida: row.nombreUnidadMedida,
                flagAfecto: row.flagIGVAfecto,
                cantidad: 1,
                pesoUnitario: row.pesoUnitario,
                totalPeso: row.pesoUnitario,
                fechaVencimiento: '',
                numeroLote: row.numeroLote,
                stock: row.stockDisponible
            };
        }

        /* CALCULOS */
        item.totalPeso = item.cantidad * item.pesoUnitario;
        /* CALCULOS */

        listaComprobanteDetalle.push(item);

        this.setState(
            {
                formValues: {
                    ...this.state.formValues,
                    listaComprobanteDetalle: listaComprobanteDetalle,
                },
            },
            () => {

                var producto = {
                    identifier: item.identifier,
                    idProducto: item.idProducto,
                    numeroLote: item.numeroLote,
                    cantidad: item.cantidad,
                    pesoUnitario: item.pesoUnitario,
                    totalPeso: item.totalPeso,
                    flagAfecto: item.flagAfecto,
                    subTotal: item.subTotal,
                    igv: item.igv,
                    pesoUnitario: item.pesoUnitario
                };


                var arrDetalle = this.state.onGetFieldValue(
                    "arrDetalle"
                );
                arrDetalle = arrDetalle.filter(
                    (m) => m.identifier !== producto.identifier
                );
                arrDetalle.push(producto);
                this.state.onSetFieldsValue({
                    totalPeso: listaComprobanteDetalle.reduce(
                        (a, b) => a + (b["totalPeso"] || 0),
                        0
                    ),
                    arrDetalle: arrDetalle
                });
            }
        );
        //   }
        // );
    };



    handleRemoverProducto = (row, form) => {

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier !== row.identifier)
            },
        }, () => {
            var arrDetalle = form.getFieldValue('arrDetalle');
            form.setFieldsValue({
                arrDetalle: arrDetalle.filter(m => m.identifier !== row.identifier)
            });
        });
    };
    handleSave = async (values, form) => {

        var envioAutomatico = this.state.configuraciones.filter((m) => m.abreviatura === EMI_GUIA_AUTO).length >= 1 ? true : false;

        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.id == 0)
                response = await guiaTransportista.registrar(values);
            else
                response = await guiaTransportista.modificar(values);
            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                this.setState({ visible: false, formValues: empty });
                form.resetFields();

                if (values.id === 0)
                    message.success('Registrado correctamente.');
                else
                    message.success('Modificado correctamente.');

                this._handlePagination(this.state.filter);

                if (envioAutomatico) {
                    setTimeout(() => {
                        this.setState({ loadingEmitir: true, loadingEdit: true });
                        this.handleEnvioComprobantes(values.id === 0 ? response.data : values.id);

                    }, 1000);
                }

                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    handleEnvioComprobantes = async (data) => {

        var response = await guiaTransportista.emitir({ id: data });

        if (response.status === 200) {
            dialog.success(response.data);
            this._handlePagination(this.state.filter);
            this.setState({ loadingEmitir: false });
            return;
        }

        if (response.status === 400) {
            dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
        }
        this._handlePagination(this.state.filter);
        this.setState({ loadingEmitir: false, loadingEdit: false });

    }


    handleSelectRowComprobante = async (row) => {

        const response = await comprobanteService.obtenerPorId(row.id);
        if (response !== undefined) {
            debugger

            formValuesComprobante.productos = [];
            formValuesComprobante.listaComprobanteDetalle = [];
            formValuesComprobante.listaComprobanteReferencia = [];
            formValuesComprobante.idComprobante = row.id;

            for (let index = 0; index < response.detalles.length; index++) {
                const element = response.detalles[index];
                formValuesComprobante.productos.push(element.idProducto);
            }

            formValuesComprobante.listaComprobanteDetalle = response.detalles;
            formValuesComprobante.listaComprobanteReferencia = response.referencias;

            this.setState({
                importarComprobanteModalVisible: true,
                importarComprobanteModal: {
                    ...this.state.importarComprobanteModal,
                    dataSourceDetalle: response.detalles
                }
            })


        }
    }

    handleOkImportarComprobante = async (values, form) => {
        debugger

        for (let index = 0; index < formValuesComprobante.listaComprobanteDetalle.length; index++) {
            const row = formValuesComprobante.listaComprobanteDetalle[index];
            var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;
            var item = {
                identifier: global.fetchUniqueCode(),
                idProducto: row.idProducto,
                codigo: row.codigoReferencia,
                nombre: row.nombre,
                nombreUnidadMedida: row.nombreUnidadMedida,
                flagAfecto: row.flagAfecto,
                cantidad: row.cantidad,
                subTotal: row.subTotal,
                igv: row.igv,
                total: row.total,
                pesoUnitario: 0,
                fechaVencimiento: '',
                numeroLote: row.numeroLote
            };

            listaComprobanteDetalle.push(item);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    listaComprobanteDetalle: listaComprobanteDetalle
                }
            });
        }

        // debugger    

        for (let index = 0; index < formValuesComprobante.listaComprobanteReferencia.length; index++) {
            const element = formValuesComprobante.listaComprobanteReferencia[index];

            var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia;

            listaComprobanteReferencia.push({
                identifier: referenciaCount,
                idReferencia: formValuesComprobante.idComprobante,
                idReferenciaOrigen: 1,
                idTipoComprobante: element.idTipoComprobante,
                serie: element.serie,
                documento: element.documento,
                flagInterno: true
            });

            referenciaCount = referenciaCount + 1;

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    listaComprobanteReferencia: listaComprobanteReferencia
                }
            });
        }

        if (formValuesComprobante.idComprobante !== null && formValuesComprobante.idComprobante > 0) {
            const responseComprobante = await comprobanteService.obtenerPorId(formValuesComprobante.idComprobante);
            const listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia;
            listaComprobanteReferencia.push({
                identifier: referenciaCount,
                idReferencia: formValuesComprobante.idComprobante,
                idReferenciaOrigen: 1,
                idTipoComprobante: responseComprobante.idTipoComprobante,
                serie: responseComprobante.serie,
                documento: responseComprobante.documento,
                flagInterno: true
            });
            referenciaCount = referenciaCount + 1;

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    listaComprobanteReferencia: listaComprobanteReferencia
                }
            });
        }

        this.setState({
            importarComprobanteModalVisible: false,
            formValues: {
                ...this.state.formValues,
                idComprobante: formValuesComprobante.idComprobante
            }
        });


    }

    setGridProductos = (data) => {
        const arrDetalle = [];
        data.guiaRemisionDetalles.forEach(element => {
            var oneProd = {
                identifier: global.fetchUniqueCode(),
                idProducto: element.idProducto,
                codigo: element.codigoReferencia,
                nombre: element.nombre,
                dam: element.dam,
                nombreUnidadMedida: element.nombreUnidadMedida,
                numeroLote: element.numeroLote,
                cantidad: element.cantidad,
                pesoUnitario: element.pesoUnitario,
                totalPeso: element.totalPeso,
                idUnidadMedida: element.idUnidadMedida,
                flagConversion: element.flagConversion,
            }
            arrDetalle.push(oneProd);
        });
        return arrDetalle;
    }

    setGridProductosDetalle = (data) => {
        const arrDetalle = [];

        data.forEach(element => {
            var oneProd = {
                identifier: element.identifier,
                idProducto: element.idProducto,
                numeroLote: element.numeroLote,
                dam: element.dam,
                cantidad: element.cantidad,
                pesoUnitario: element.pesoUnitario,
                totalPeso: element.totalPeso,
                flagAfecto: element.flagAfecto,
                subTotal: 0,
                igv: 0,
                idUnidadMedida: element.idUnidadMedida,
                flagConversion: element.flagConversion,
            };


            arrDetalle.push(oneProd);
        });
        return arrDetalle;
    }

    setGridReferencias = (data) => {
        debugger
        const detalleReferencias = [];
        data.guiaRemisionReferencias.forEach((element, index) => {
            debugger

            var oneRef = {
                identifier: referenciaCount,
                idReferencia: element.id,
                idReferenciaOrigen: element.idReferenciaOrigen,
                idTipoComprobante: element.idTipoComprobante,
                serie: element.serie,
                documento: element.documento,
                flagInterno: true,
                nombreTipoComprobante: element.nombreTipoComprobante
            }
            referenciaCount = referenciaCount + 1;

            detalleReferencias.push(oneRef);
        });

        return detalleReferencias;
    }

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await guiaTransportista.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Guia Transportista.xlsx");
    };

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await guiaTransportista.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Guia Transportista.pdf");
    };



    handleVer = async (values) => {
        debugger
        this.setState({ loadingVer: true });
        const response = await guiaTransportista.obtenerPorId(values.id);
        if (response !== undefined) {

            var formValues = {
                id: response.guiaTransportista.id,
                idProyecto: response.guiaTransportista.idProyecto,
                idVehiculo: response.guiaTransportista.idVehiculo,
                idChofer: response.guiaTransportista.idChofer,
                idUsuarioRegistro: auth.user().id,
                idEstablecimientoPartida: response.guiaTransportista.idEstablecimientoPartida,
                idEstablecimientoDestino: response.guiaTransportista.idEstablecimientoDestino,
                idDepartamentoPartida: response.guiaTransportista.idDepartamentoPartida,
                idProvinciaPartida: response.guiaTransportista.idProvinciaPartida,
                idDistritoPartida: response.guiaTransportista.idDistritoPartida,
                idDepartamentoLlegada: response.guiaTransportista.idDepartamentoLlegada,
                idProvinciaLlegada: response.guiaTransportista.idProvinciaLlegada,
                idDistritoLlegada: response.guiaTransportista.idDistritoLlegada,
                nroMtc: response.guiaTransportista.nroMtc,
                idIndicadorSunat: response.guiaTransportista.idIndicadorSunat,

                serie: response.guiaTransportista.serie,
                documento: response.guiaTransportista.documento,
                fechaStr: response.guiaTransportista.fechaStr,
                fechaTrasladoStr: response.guiaTransportista.fechaTrasladoStr,
                observacion: response.guiaTransportista.observacion,
                licencia: response.guiaTransportista.licencia,
                tuc: response.guiaTransportista.tuc,
                totalPeso: response.guiaTransportista.totalPeso,
                activeKey: "1",
                idDestinatario: response.guiaTransportista.idDestinatario,
                idRemitente: response.guiaTransportista.idRemitente,
                documentoRemitente: response.guiaTransportista.numeroDocumentoRemitente,
                documentoDestinatario: response.guiaTransportista.numeroDocumentoDestinatario,
                direccionPartida: response.guiaTransportista.direccionPartida,
                direccionDestino: response.guiaTransportista.direccionDestino,
                detalleProductos: [],
                listaComprobanteDetalle: [],
                listaComprobanteReferencia: [],
            }
            response.guiaTransportistaDetalles.forEach((element) => {
                const identifier = global.fetchUniqueCode();
                formValues.listaComprobanteDetalle.push({
                    identifier: identifier,
                    idProducto: element.idProducto,
                    codigo: element.codigoReferencia,
                    nombre: element.nombre,
                    dam: element.dam,
                    nombreUnidadMedida: element.nombreUnidadMedida,
                    numeroLote: element.numeroLote,
                    cantidad: element.cantidad,
                    pesoUnitario: element.pesoUnitario,
                    totalPeso: element.totalPeso,
                    idUnidadMedida: element.idUnidadMedida,
                    flagConversion: element.flagConversion,
                });
            });
            formValues.detalleProductos = formValues.listaComprobanteDetalle;

            response.guiaTransportistaReferencias.forEach((element, index) => {
                var oneRef = {
                    identifier: global.fetchUniqueCode(),
                    idReferencia: element.id,
                    idReferenciaOrigen: element.idReferenciaOrigen,
                    idTipoComprobante: element.idTipoComprobante,
                    serie: element.serie,
                    documento: element.documento,
                    flagInterno: true,
                    nombreTipoComprobante: element.nombreTipoComprobante
                }
                formValues.listaComprobanteReferencia.push(oneRef);
            });

            formValues.proyectos = this.state.proyectos;
            formValues.unidadesMedida = this.state.unidadesMedida;

            //this.state.almacenes;
            formValues.choferes = this.state.choferes;
            formValues.destinatarios = this.state.destinatarios;
            formValues.tiposComprobante = this.state.tiposComprobante;
            formValues.remitentes = this.state.remitentes;

            const direccionPartida = await establecimientoService.listarPorIdEntidad(formValues.idRemitente)
            const departamentosPartida = await ubigeoService.departamentos()
            const provinciasPartida = await ubigeoService.provincias(formValues.idDepartamentoPartida);
            const distritosPartida = await ubigeoService.distritos(formValues.idProvinciaPartida);

            formValues.direccionesPartidas = direccionPartida;

            const direccionLlegada = await establecimientoService.listarPorIdEntidad(formValues.idDestinatario)
            const departamentosLlegada = await ubigeoService.departamentos()
            const provinciasLlegada = await ubigeoService.provincias(formValues.idDepartamentoLlegada);
            const distritosLlegada = await ubigeoService.distritos(formValues.idProvinciaLlegada);

            formValues.direccionesLlegadas = direccionLlegada;

            formValues.departamentosPartida = departamentosPartida;
            formValues.departamentosLlegada = departamentosLlegada;

            formValues.provinciasPartida = provinciasPartida;
            formValues.provinciasLlegada = provinciasLlegada;

            formValues.distritosPartida = distritosPartida;
            formValues.distritosLlegada = distritosLlegada;

            formValues.vehiculos = this.state.vehiculos;
            formValues.indicadorSunat = this.state.indicadorSunat;

            this.setState({
                visibleVer: true,
                loadingVer: false,
                formValues,
            });
        }
    }


    handleEdit = async (values) => {

        var flagEditCode = this.state.configuraciones.filter((m) => m.abreviatura === EDIT_COD_GUIA).length >= 1 ? true : false;

        this.setState({ loadingEdit: true });
        const response = await guiaTransportista.obtenerPorId(values.id);
        if (response !== undefined) {

            var formValues = {
                id: values.id,
                idProyecto: response.guiaTransportista.idProyecto,
                idVehiculo: response.guiaTransportista.idVehiculo,
                idChofer: response.guiaTransportista.idChofer,
                idUsuarioRegistro: auth.user().id,
                idEstablecimientoPartida: response.guiaTransportista.idEstablecimientoPartida,
                idEstablecimientoDestino: response.guiaTransportista.idEstablecimientoDestino,
                idDepartamentoPartida: response.guiaTransportista.idDepartamentoPartida,
                idProvinciaPartida: response.guiaTransportista.idProvinciaPartida,
                idDistritoPartida: response.guiaTransportista.idDistritoPartida,
                idDepartamentoLlegada: response.guiaTransportista.idDepartamentoLlegada,
                idProvinciaLlegada: response.guiaTransportista.idProvinciaLlegada,
                idDistritoLlegada: response.guiaTransportista.idDistritoLlegada,
                serie: response.guiaTransportista.serie,
                documento: response.guiaTransportista.documento,
                fechaStr: response.guiaTransportista.fechaStr,
                fechaTrasladoStr: response.guiaTransportista.fechaTrasladoStr,
                observacion: response.guiaTransportista.observacion,
                licencia: response.guiaTransportista.licencia,
                tuc: response.guiaTransportista.tuc,
                totalPeso: response.guiaTransportista.totalPeso,
                activeKey: "1",
                idDestinatario: response.guiaTransportista.idDestinatario,
                idRemitente: response.guiaTransportista.idRemitente,
                documentoRemitente: response.guiaTransportista.numeroDocumentoRemitente,
                documentoDestinatario: response.guiaTransportista.numeroDocumentoDestinatario,
                direccionPartida: response.guiaTransportista.direccionPartida,
                direccionDestino: response.guiaTransportista.direccionDestino,
                flagEditdireccionPartida: response.guiaTransportista.flagEditdireccionPartida,
                flagEditdireccionDestino: response.guiaTransportista.flagEditdireccionDestino,
                flagEditCode: flagEditCode,

                idIndicadorSunat: response.guiaTransportista.idIndicadorSunat,
                documentoTercero: response.guiaTransportista.documentoTercero,
                razonSocialTercero: response.guiaTransportista.razonSocialTercero,
                flagTercero: response.guiaTransportista.flagTercero,
                flagSubcontrato: response.guiaTransportista.flagSubcontrato,
                nroMtc: response.guiaTransportista.nroMtc,

                flagCategoria: response.guiaTransportista.flagCategoria,
                flagProgramado: response.guiaTransportista.flagProgramado,
                flagVehiculoVacio: response.guiaTransportista.flagVehiculoVacio,
                flagEmbalajeVacio: response.guiaTransportista.flagEmbalajeVacio,

                detalleProductos: [],
                listaComprobanteDetalle: [],
                listaComprobanteReferencia: [],
                vehiculosSecundarios: [],
                choferesSecundarios: [],
            }
            response.guiaTransportistaDetalles.forEach((element) => {
                const identifier = global.fetchUniqueCode();
                var item = {
                    identifier: identifier,
                    idProducto: element.idProducto,
                    codigo: element.codigoReferencia,
                    nombre: element.nombre,
                    dam: element.dam,
                    nombreUnidadMedida: element.nombreUnidadMedida,
                    numeroLote: element.numeroLote,
                    cantidad: element.cantidad,
                    pesoUnitario: element.pesoUnitario,
                    totalPeso: element.totalPeso,
                    idUnidadMedida: element.idUnidadMedida,
                    flagConversion: element.flagConversion,
                }


                formValues.listaComprobanteDetalle.push(item);
                formValues.detalleProductos.push(item);

            });

            response.guiaTransportistaReferencias.forEach((element, index) => {
                var oneRef = {
                    identifier: global.fetchUniqueCode(),
                    idReferencia: element.id,
                    idReferenciaOrigen: element.idReferenciaOrigen,
                    idTipoComprobante: element.idTipoComprobante,
                    serie: element.serie,
                    documento: element.documento,
                    flagInterno: true,
                    nombreTipoComprobante: element.nombreTipoComprobante
                }
                formValues.listaComprobanteReferencia.push(oneRef);
            });

            response.guiaTransportistaVehiculos.forEach((element, index) => {
                var oneRef = {
                    identifier: global.fetchUniqueCode(),
                    placa: element.placa,
                    tuc: element.tuc,
                    idVehiculo: element.idVehiculo,
                    flagInterno: true,
                }
                formValues.vehiculosSecundarios.push(oneRef);
            });

            response.guiaTransportistaChoferes.forEach((element, index) => {
                var oneRef = {
                    identifier: global.fetchUniqueCode(),
                    idChofer: element.idChofer,
                    nombres: element.nombres,
                    licencia: element.licencia,
                    flagInterno: true,
                }
                formValues.choferesSecundarios.push(oneRef);
            });

            formValues.proyectos = this.state.proyectos;
            formValues.unidadesMedida = this.state.unidadesMedida;



            //this.state.almacenes;
            formValues.choferes = this.state.choferes;
            formValues.destinatarios = this.state.destinatarios;
            formValues.tiposComprobante = this.state.tiposComprobante;
            formValues.remitentes = this.state.remitentes;
            formValues.indicadorSunat = this.state.indicadorSunat;

            const direccionPartida = await establecimientoService.listarPorIdEntidad(formValues.idRemitente)
            const departamentosPartida = await ubigeoService.departamentos()
            const provinciasPartida = await ubigeoService.provincias(formValues.idDepartamentoPartida);
            const distritosPartida = await ubigeoService.distritos(formValues.idProvinciaPartida);

            formValues.direccionesPartidas = direccionPartida;

            var _valorPartida = formValues.flagEditdireccionPartida ? formValues.direccionPartida : direccionPartida[0].direccion;

            formValues.direccionPartida = _valorPartida;

            const direccionLlegada = await establecimientoService.listarPorIdEntidad(formValues.idDestinatario)
            const departamentosLlegada = await ubigeoService.departamentos()
            const provinciasLlegada = await ubigeoService.provincias(formValues.idDepartamentoLlegada);
            const distritosLlegada = await ubigeoService.distritos(formValues.idProvinciaLlegada);

            formValues.direccionesLlegadas = direccionLlegada;
            var _valorLlegada = formValues.flagEditdireccionDestino ? formValues.direccionDestino : direccionLlegada[0].direccion;
            formValues.direccionDestino = _valorLlegada;



            formValues.departamentosPartida = departamentosPartida;
            formValues.departamentosLlegada = departamentosLlegada;

            formValues.provinciasPartida = provinciasPartida;
            formValues.provinciasLlegada = provinciasLlegada;

            formValues.distritosPartida = distritosPartida;
            formValues.distritosLlegada = distritosLlegada;

            formValues.vehiculos = this.state.vehiculos;

            this.setState({
                visible: true,
                loadingEdit: false,
                formValues,
                prodsArrDetalle: formValues.listaComprobanteDetalle

            });
        }
    }

    handleAnular = async (values) => {
        dialog.confirm("Esta acción solo indicara que la Guía de Remisión seleccionada esta inutilizada para un control interno, esta no será anulada en la SUNAT", async () => {
            var response = await guiaTransportista.eliminar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    }

    handleCopy = async (values) => {

        var flagEditCode = this.state.configuraciones.filter((m) => m.abreviatura === EDIT_COD_GUIA).length >= 1 ? true : false;

        this.setState({ loadingEdit: true });

        const response = await guiaTransportista.obtenerPorId(values.id);
        if (response !== undefined) {

            var formValues = {
                id: 0,
                idProyecto: response.guiaTransportista.idProyecto,
                idVehiculo: response.guiaTransportista.idVehiculo,
                idChofer: response.guiaTransportista.idChofer,
                idUsuarioRegistro: auth.user().id,
                idEstablecimientoPartida: response.guiaTransportista.idEstablecimientoPartida,
                idEstablecimientoDestino: response.guiaTransportista.idEstablecimientoDestino,
                idDepartamentoPartida: response.guiaTransportista.idDepartamentoPartida,
                idProvinciaPartida: response.guiaTransportista.idProvinciaPartida,
                idDistritoPartida: response.guiaTransportista.idDistritoPartida,
                idDepartamentoLlegada: response.guiaTransportista.idDepartamentoLlegada,
                idProvinciaLlegada: response.guiaTransportista.idProvinciaLlegada,
                idDistritoLlegada: response.guiaTransportista.idDistritoLlegada,
                serie: response.guiaTransportista.serie,
                documento: response.guiaTransportista.documento,
                fechaStr: response.guiaTransportista.fechaStr,
                fechaTrasladoStr: response.guiaTransportista.fechaTrasladoStr,
                observacion: response.guiaTransportista.observacion,
                licencia: response.guiaTransportista.licencia,
                tuc: response.guiaTransportista.tuc,
                totalPeso: response.guiaTransportista.totalPeso,
                activeKey: "1",
                idDestinatario: response.guiaTransportista.idDestinatario,
                idRemitente: response.guiaTransportista.idRemitente,
                documentoRemitente: response.guiaTransportista.numeroDocumentoRemitente,
                documentoDestinatario: response.guiaTransportista.numeroDocumentoDestinatario,
                direccionPartida: response.guiaTransportista.direccionPartida,
                direccionDestino: response.guiaTransportista.direccionDestino,
                flagEditdireccionPartida: response.guiaTransportista.flagEditdireccionPartida,
                flagEditdireccionDestino: response.guiaTransportista.flagEditdireccionDestino,
                flagEditCode: flagEditCode,

                idIndicadorSunat: response.guiaTransportista.idIndicadorSunat,
                documentoTercero: response.guiaTransportista.documentoTercero,
                razonSocialTercero: response.guiaTransportista.razonSocialTercero,
                flagTercero: response.guiaTransportista.flagTercero,
                flagSubcontrato: response.guiaTransportista.flagSubcontrato,
                nroMtc: response.guiaTransportista.nroMtc,

                flagCategoria: response.guiaTransportista.flagCategoria,
                flagProgramado: response.guiaTransportista.flagProgramado,
                flagVehiculoVacio: response.guiaTransportista.flagVehiculoVacio,
                flagEmbalajeVacio: response.guiaTransportista.flagEmbalajeVacio,

                detalleProductos: [],
                listaComprobanteDetalle: [],
                listaComprobanteReferencia: [],
                vehiculosSecundarios: [],
                choferesSecundarios: [],
            }
            response.guiaTransportistaDetalles.forEach((element) => {
                const identifier = global.fetchUniqueCode();
                var item = {
                    identifier: identifier,
                    idProducto: element.idProducto,
                    codigo: element.codigoReferencia,
                    nombre: element.nombre,
                    dam: element.dam,
                    nombreUnidadMedida: element.nombreUnidadMedida,
                    numeroLote: element.numeroLote,
                    cantidad: element.cantidad,
                    pesoUnitario: element.pesoUnitario,
                    totalPeso: element.totalPeso,
                    idUnidadMedida: element.idUnidadMedida,
                    flagConversion: element.flagConversion,
                }


                formValues.listaComprobanteDetalle.push(item);
                formValues.detalleProductos.push(item);

            });

            response.guiaTransportistaVehiculos.forEach((element, index) => {
                var oneRef = {
                    identifier: global.fetchUniqueCode(),
                    placa: element.placa,
                    tuc: element.tuc,
                    idVehiculo: element.idVehiculo,
                    flagInterno: true,
                }
                formValues.vehiculosSecundarios.push(oneRef);
            });

            response.guiaTransportistaChoferes.forEach((element, index) => {
                var oneRef = {
                    identifier: global.fetchUniqueCode(),
                    idChofer: element.idChofer,
                    nombres: element.nombres,
                    licencia: element.licencia,
                    flagInterno: true,
                }
                formValues.choferesSecundarios.push(oneRef);
            });

            formValues.proyectos = this.state.proyectos;
            formValues.unidadesMedida = this.state.unidadesMedida;



            //this.state.almacenes;
            formValues.choferes = this.state.choferes;
            formValues.destinatarios = this.state.destinatarios;
            formValues.tiposComprobante = this.state.tiposComprobante;
            formValues.remitentes = this.state.remitentes;
            formValues.indicadorSunat = this.state.indicadorSunat;

            const direccionPartida = await establecimientoService.listarPorIdEntidad(formValues.idRemitente)
            const departamentosPartida = await ubigeoService.departamentos()
            const provinciasPartida = await ubigeoService.provincias(formValues.idDepartamentoPartida);
            const distritosPartida = await ubigeoService.distritos(formValues.idProvinciaPartida);

            formValues.direccionesPartidas = direccionPartida;

            var _valorPartida = formValues.flagEditdireccionPartida ? formValues.direccionPartida : direccionPartida[0].direccion;

            formValues.direccionPartida = _valorPartida;

            const direccionLlegada = await establecimientoService.listarPorIdEntidad(formValues.idDestinatario)
            const departamentosLlegada = await ubigeoService.departamentos()
            const provinciasLlegada = await ubigeoService.provincias(formValues.idDepartamentoLlegada);
            const distritosLlegada = await ubigeoService.distritos(formValues.idProvinciaLlegada);

            formValues.direccionesLlegadas = direccionLlegada;
            var _valorLlegada = formValues.flagEditdireccionDestino ? formValues.direccionDestino : direccionLlegada[0].direccion;
            formValues.direccionDestino = _valorLlegada;



            formValues.departamentosPartida = departamentosPartida;
            formValues.departamentosLlegada = departamentosLlegada;

            formValues.provinciasPartida = provinciasPartida;
            formValues.provinciasLlegada = provinciasLlegada;

            formValues.distritosPartida = distritosPartida;
            formValues.distritosLlegada = distritosLlegada;

            formValues.vehiculos = this.state.vehiculos;

            this.setState({
                visible: true,
                loadingEdit: false,
                formValues,
                prodsArrDetalle: formValues.listaComprobanteDetalle

            });
        }
    }
    handleBuscarDestinatario = async (value, form) => {
        this.setState({ formValues: { ...this.state.formValues, destinatarioLoading: true } });


        var numberDocument = value;
        if (numberDocument == "" || numberDocument == "null" || numberDocument == "undefined") {
            dialog.warning(<ul>Ingrese documento valido</ul>);
            return;
        }

        var response = numberDocument.length == 8 ? await padronReducidoService.obtenerDniApi(value) :
            await padronReducidoService.obtenerRucApi(value);

        if (response.status === 200) {
            const provinciasLlegada = await ubigeoService.provincias(response.data.direcciones[0].idDepartamento);
            const distritosLlegada = await ubigeoService.distritos(response.data.direcciones[0].idProvincia);

            const filterEntidad = {
                numeroDocumento: null,
                idTipoComprobante: OTROS.ID// FACTURA.ID
            }
            const entidades = await entidadService.obtenerTodos(filterEntidad);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    destinatarioLoading: false,
                    documentoDestinatario: response.data.numeroDocumento,
                    provinciasLlegada: provinciasLlegada,
                    distritosLlegada: distritosLlegada,
                    direccionesLlegadas: response.data.direcciones,
                    direccionLlegada: response.data.direcciones[0].direccion,
                },
                destinatarios: entidades
            }, () => {
                form.setFieldsValue({
                    destinatarios: entidades,
                    documentoDestinatario: response.data.numeroDocumento,
                    idDestinatario: response.data.clientes.length > 0 ? { key: response.data.idEntidad } : undefined,
                    idEstablecimientoDestino: response.data.direcciones.length > 0 && response.data.direcciones[0].id ? { key: response.data.direcciones[0].id } : undefined,
                    idDepartamentoLlegada: response.data.direcciones.length > 0 && response.data.direcciones[0].idDepartamento != 0 ? { key: response.data.direcciones[0].idDepartamento } : undefined,
                    idProvinciaLlegada: response.data.direcciones.length > 0 && response.data.direcciones[0].idProvincia != 0 ? { key: response.data.direcciones[0].idProvincia } : undefined,
                    idDistritoLlegada: response.data.direcciones.length > 0 && response.data.direcciones[0].idUbigeo != 0 ? { key: response.data.direcciones[0].idUbigeo } : undefined
                });
            });
        }
        else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    destinatarioLoading: false,
                    direcciones: [],
                }
            }, () => {
                form.setFieldsValue({
                    destinatarios: [],
                    idProvinciaLlegada: undefined,
                    idDepartamentoLlegada: undefined,
                    idUbigeo: undefined,
                    idDestinatario: undefined,
                    idEstablecimientoCliente: undefined
                });
            });
        }
    };

    handleChangeNameProduct = (row) => {
        var flagEditCode = this.state.configuraciones.filter((m) => m.abreviatura === EDIT_COD_GUIA).length >= 1 ? true : false;

        this.setState({
            renombrarProductoVisible: true,
            renombrarProductoModal: {
                ...this.state.renombrarProductoModal,
                nombre: row.nombre,
                idProducto: row.idProducto,
                identifier: row.identifier,
                codigo: row.codigo,
                flagEditCode: auth.user().planCode == "PLA001" ? flagEditCode : false,

            }
        })
    }

    handleOkChangeNameProduct = (value, form) => {

        var listaComprobanteDetalle_aux = this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier !== value.identifier);
        var currentRow = this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier === value.identifier)[0];
        var currentRowIndex = this.state.formValues.listaComprobanteDetalle.findIndex(m => m.identifier === value.identifier);
        currentRow.nombre = value.nombre;
        currentRow.codigo = value.codigo;

        // listaComprobanteDetalle_aux.push(currentRow);
        listaComprobanteDetalle_aux.splice(currentRowIndex, 0, currentRow);

        var empty_renombrarProductoModal = {
            nombre: '',
            idProducto: 0,
            identifier: '',
            codigo: ''
        };

        form.setFieldsValue(empty_renombrarProductoModal);
        form.resetFields();
        this.setState({
            renombrarProductoVisible: false,
            renombrarProductoModal: {
                ...this.state.renombrarProductoModal,
                nombre: '',
                idProducto: 0,
                identifier: '',
                codigo: ''
            },
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle_aux
            }
        });
    }

    handleImprimir = async (item) => {

        this.setState({ loadingImprimir: true });

        var file = undefined;
        var response = undefined;
        var idFormato = this.state.company.formatoPrint;
        var isEpson = JSON.parse(localStorage.getItem("isEpson"));

        if (idFormato === 1) {
            response = await guiaTransportista.pdfA4({ id: item.id });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {
            response = await guiaTransportista.ticket({
                id: item.id,
                isEpson: isEpson == null ? false : isEpson
            });
            file = window.URL.createObjectURL(response.data);
        }
        if (idFormato === 3) {
            response = await guiaTransportista.ticket50({ id: item.id });
            file = window.URL.createObjectURL(response.data);
        }
        this.setState({ loadingImprimir: false });

        this.setState({
            imprimirVisible: true,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                file,
                fileName: item.serie + '-' + item.documento,
                idGuiaRemision: item.id,
                idFormato: idFormato
            }
        });
    };


    handleDownloadPdf = async () => {
        global.downloadFileBlob(this.state.imprimirFormValues.file, this.state.imprimirFormValues.fileName + ".pdf");
    };

    handleSwitch = async (e) => {
        localStorage.setItem("isEpson", JSON.stringify(e))
        this.setState({
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                isEpson: e,
            }
        })

        setTimeout(() => {
            this.handleChangeImprimir(2)
        }, 100);
    }

    handleChangeImprimir = async (idFormato) => {
        var file = undefined;
        var response = undefined;
        if (idFormato === 1) {
            response = await guiaTransportista.pdfA4({ id: this.state.imprimirFormValues.idGuiaRemision });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {
            response = await guiaTransportista.ticket({
                id: this.state.imprimirFormValues.idGuiaRemision,
                isEpson: JSON.parse(localStorage.getItem("isEpson")),
            });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 3) {
            response = await guiaTransportista.ticket50({ id: this.state.imprimirFormValues.idGuiaRemision });
            file = window.URL.createObjectURL(response.data);
        }

        this.setState({
            imprimirVisible: true,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                file,
                idFormato,
                isEpson: JSON.parse(localStorage.getItem("isEpson")),
            }
        });
    };



    handleImportarComprobante = async (onSetFieldsValue, onGetFieldValue) => {

        this.setState({
            onSetFieldsValue,
            onGetFieldValue
        }, async () => {
            var idDestinatario = this.state.onGetFieldValue('idDestinatario');

            if (idDestinatario === undefined || idDestinatario.key === 0) {
                message.warning('Por favor busque y/o seleccione un cliente.');
                return;
            }

            var filter = {
                idDestinatario: idDestinatario.key,
                serie: '',
                documento: '',
            }

            var response = await comprobanteService.importarRegistradosEmitidos(filter);

            this.setState({
                importarComprobanteVisible: true,
                importarFormValues: {
                    dataSource: response
                }
            });
        });
    };

    handleSelectComprobante = async (row) => {

        var response = await comprobanteService.obtenerPorId(row.id);

        if (response === undefined) {
            dialog.error("Ocurrió un error mientras se obtenia los datos.");
            return;
        }

        var productos = [];
        var listaComprobanteDetalle = [];
        var listaComprobanteReferencia = [];

        response.detalles.forEach(element => {
            const identifier = global.fetchUniqueCode();

            listaComprobanteDetalle.push({
                identifier: identifier,
                idProducto: element.idProducto,
                codigo: element.codigoReferencia,
                nombre: element.nombre,
                numeroLote: element.numeroLote,
                nombreUnidadMedida: element.nombreUnidadMedida,
                idUnidadMedida: element.idUnidadMedida,
                flagAfecto: element.flagAfecto,
                cantidad: element.cantidad,
                pesoUnitario: element.pesoUnitario,
                totalPeso: element.totalPeso,
                flagConversion: element.flagConversion,

            });

            productos.push({
                identifier: identifier,
                idProducto: element.idProducto,
                codigo: element.codigoReferencia,
                nombre: element.nombre,
                numeroLote: element.numeroLote,
                nombreUnidadMedida: element.nombreUnidadMedida,
                idUnidadMedida: element.idUnidadMedida,
                flagAfecto: element.flagAfecto,
                cantidad: element.cantidad,
                pesoUnitario: element.pesoUnitario,
                totalPeso: element.totalPeso,
                flagConversion: element.flagConversion,

            });
        });

        listaComprobanteReferencia.push({
            identifier: referenciaCount,
            idReferencia: response.id,
            idReferenciaOrigen: 1,
            idTipoComprobante: response.idTipoComprobante,
            serie: response.serie,
            documento: response.documento,
            flagInterno: true
        });


        const almacenes = await almacenService.listarPorIdEstablecimiento(response.idEstablecimiento);
        const listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === response.idEstablecimiento);
        this.setState({
            formValues: {
                ...this.state.formValues,
                almacenes: almacenes,
                listasPrecio: listasPrecio,
                idEstablecimiento: response.idEstablecimiento,
                idAlmacen: response.idAlmacen,
                idMoneda: response.idMoneda,
                idProyecto: response.idProyecto,
                idListaPrecio: response.idListaPrecio,
                listaComprobanteDetalle: listaComprobanteDetalle,
                listaComprobanteReferencia: listaComprobanteReferencia,
                activeKey: "2"
            }
        }, () => {
            var detalleProductos = [];
            productos.forEach(producto => {
                detalleProductos.push(producto);
            });

            this.state.onSetFieldsValue({
                arrDetalle: detalleProductos,
                arrReferencia: listaComprobanteReferencia,
                idEstablecimiento: { key: response.idEstablecimiento },
                idAlmacen: { key: response.idAlmacen },
                idProyecto: { key: response.idProyecto },
                idMoneda: { key: response.idMoneda },
                idListaPrecio: { key: response.idListaPrecio },
                idTipoComprobanteImportado: response.idTipoComprobante,
                totalPeso: response.totalPeso,
            });
        });
    };

    handleOpenEmitirModal = async (item) => {
        this.setState({ loadingEmitir: true });

        this.handleEmitir(item);

    };

    handleCorreo = async (item) => {
        this.setState({
            loadingCorreo: false,
            correoVisible: true,
            correoFormValues: {
                ...this.state.correoFormValues,
                idComprobante: item.id,
                idFormato: 1, // A4
                correoCliente: item.correoCliente
            }
        });
    };


    handleEmitir = async (item) => {
        item = this.state.emitirVisible ? this.state.selectedItem : item;

        dialog.confirm("¿Desea enviar la guía de remisión a sunat " + item.serieDocumento + " ?", async () => {

            var response = await guiaTransportista.emitir({ id: item.id });

            this.setState({ loadingEmitir: false });

            if (response.status === 200) {
                //form.resetFields();
                dialog.success(response.data);
                this._handlePagination(this.state.filter);
                this.setState({ emitirVisible: false });
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }
            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        }, async () => { this.setState({ loadingEmitir: false }) });
    };


    handleDownloadXml = async () => {
        this.setState({ loadingXml: true });

        var response = await guiaTransportista.xml({ id: this.state.selectedItem.id });
        if (response !== undefined)
            global.dowloadFile(response.data, this.state.selectedItem.nombreXML);

        this.setState({ loadingXml: false });

    };

    handleDownloadCdr = async () => {
        this.setState({ loadingXml: true });

        var response = await guiaTransportista.cdr({ id: this.state.selectedItem.id });
        if (response !== undefined)
            global.dowloadFile(response.data, this.state.selectedItem.nombreCDR);

        this.setState({ loadingXml: false });

    };

    handleOpenCdrModal = async (row) => {

        this.setState({
            cdrVisible: true,
            selectedItem: row
        });
    };

    async componentDidMount() {
        var idUsuario = auth.user().id;

        const datosIniciales = await comprobanteService.datosIniciales({ idUsuario: auth.user().id, idTipoComprobante: GUIA_TRANSPORTISTA.ID });

        const configuraciones = await configuracionService.obtenerPorModulo({ idUsuario: idUsuario, idModulo: VENTA });
        var flagSerie = configuraciones.filter((m) => m.abreviatura === VER_SERIES_VENTA).length >= 1 ? true : false;
        const serie = [undefined, null].includes(datosIniciales?.serie) ? flagSerie ? '' : '-' : datosIniciales.serie;



        this.setState({ filter: { ...this.state.filter, serie } });

        this._initPagination(this.state.filter, guiaTransportista.paginacion);
        const response = await guiaService.listar();


        const establecimientos = response.list_Establecimiento.result;
        const tiposComprobante = response.list_TipoComprobante.result;
        const vehiculos = response.list_Vehiculo.result;
        const choferes = response.list_Chofer.result;
        const _ubigeos = response.list_Ubigeo.result;
        const estado = await guiaTransportista.listarEstado();
        const proyectos = response.list_Proyecto.result;
        const totaldocument = response.list_TotalComprobante.result;
        const company = response.list_Empresa;

        /* 
                const establecimientos = await establecimientoService.principales();
                const tiposComprobante = await tipoComprobanteService.listar();
                const vehiculos = await vehiculoService.listar();
                const choferes = await choferService.listar();
                const _ubigeos = await ubigeoService.listar();
                const estado = await guiaTransportista.listarEstado();
                const proyectos = await proyectoService.listar(); */


        const filterEntidad = {
            numeroDocumento: null,
            idTipoComprobante: OTROS.ID// FACTURA.ID
        }
        const entidades = await entidadService.obtenerTodos(filterEntidad);
        const indicadorSunat = await guiaTransportista.listarIndicadorSunat();

        this.setState({
            loadingSource: false,
            tiposCambioDiario: [],
            direccionesPartidas: establecimientos ? establecimientos : [],
            vendedores: [],
            listasPrecio: [],
            tiposGuia: [],
            vehiculos: vehiculos ? vehiculos : [],
            choferes: choferes ? choferes : [],
            destinatarios: entidades ? entidades : [],
            proyectos: proyectos ? proyectos : [],
            tiposComprobante: tiposComprobante ? tiposComprobante.filter(e => e.flagGRET) : [],
            ubigeos: _ubigeos ? _ubigeos : [],
            estado: estado ? estado : [],
            remitentes: entidades ? entidades : [],
            indicadorSunat: indicadorSunat ? indicadorSunat : [],
            configuraciones: configuraciones ? configuraciones : [],
            totaldocument: totaldocument ? totaldocument : [],
            company: company
        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Guía de Remisión Transportista"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination(this.state.filter)}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                    estado={this.state.estado}
                    proyectos={this.state.proyectos}
                    configuraciones={this.state.configuraciones}


                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingEdit}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingVer={this.state.loadingVer}
                    loadingImprimir={this.state.loadingImprimir}
                    loadingCopy={this.state.loadingCopy || this.state.loadingSource}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onCorreo={this.handleCorreo}
                    onVer={this.handleVer}
                    onEditar={this.handleEdit}
                    onCopy={this.handleCopy}
                    onAnular={this.handleAnular}
                    onChange={this._handleChangePagination}
                    onImprimir={this.handleImprimir}
                    onEmitir={this.handleOpenEmitirModal}
                    onCdr={this.handleOpenCdrModal}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onBuscarRemitente={this.handleBuscarRemitente}
                    onBuscarDestinatario={this.handleBuscarDestinatario}
                    onChangeEntidad={this.handleOnChangeEntidad}
                    onAgregarDetalle={this.handleAgregarDetalle}
                    onRemoverProducto={this.handleRemoverProducto}
                    onRemoverReferencia={this.handleRemoverReferencia}
                    onRemoveVehiculo={this.handleRemoverVehiculo}
                    onRemoveChofer={this.handleRemoverChofer}
                    onChangeTab={this.handleChangeTab}
                    onChange={this.handleChangeForm}
                    onImportarComprobante={this.handleImportarComprobante}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                    onChangeNameProduct={this.handleChangeNameProduct}
                    onScanerProduct={this.handleScanerProduct}
                    onBuscarTercero={this.handleBuscarTercero}
                    arrDetalle={this.state.prodsArrDetalle}

                />
                <FormModalVer
                    visible={this.state.visibleVer}
                    formValues={this.state.formValues}
                    onChangeTab={this.handleChangeTab}
                    onClose={() => this.setState({ visibleVer: false })}
                />

                <SearchProductModal
                    onBuscarProducto={this.handleBuscarProducto}
                    visible={this.state.searchProductVisible}
                    validarStock={this.state.searchProductFormValues.validarStock}
                    dataSource={this.state.searchProductFormValues.dataSource}
                    dataSourceAgregado={this.state.formValues.listaComprobanteDetalle}
                    onSelect={this.handleSelectProduct}
                    idSistema={LOGISTICA}
                    onCancel={() => this.setState({ searchProductVisible: false })}
                />

                <RenombrarProductoModal
                    visible={this.state.renombrarProductoVisible}
                    formValues={this.state.renombrarProductoModal}
                    onCancel={() => this.setState({ renombrarProductoVisible: false })}
                    onSaveRename={this.handleOkChangeNameProduct}
                />

                <ImprimirModal
                    visible={this.state.imprimirVisible}
                    formValues={this.state.imprimirFormValues}
                    onChange={this.handleChangeImprimir}
                    onDownload={this.handleDownloadPdf}
                    onSwitch={this.handleSwitch}
                    onClose={() => this.setState({ imprimirVisible: false })}
                />
                <ImportarModal
                    tittle="Búsqueda de Facturas / Boletas"
                    visible={this.state.importarComprobanteVisible}
                    formValues={this.state.importarFormValues}
                    dataSource={this.state.importarFormValues.dataSource}
                    onSelect={this.handleSelectComprobante}
                    onClose={() => this.setState({ importarComprobanteVisible: false })}
                />

                <CdrModal
                    loadingXml={this.state.loadingXml}
                    visible={this.state.cdrVisible}
                    item={this.state.selectedItem}
                    onDownloadXml={this.handleDownloadXml}
                    onDownloadCdr={this.handleDownloadCdr}
                    onClose={() => this.setState({ cdrVisible: false })}
                />
            </div>
        )
    }

}